module.exports = __webpack_public_path__ + "media/images/add-file-8c32ca22.png";